(function () {
  if (window.__bundleBallesInit) return;
  window.__bundleBallesInit = true;

  function readVariantsJSON(variantSelectsEl) {
    const script = variantSelectsEl.querySelector('script[type="application/json"][data-variants]');
    if (!script) return [];
    try { return JSON.parse(script.textContent.trim()); } catch (e) { return []; }
  }

  function getCurrentSelections(variantSelectsEl) {
    const selections = [];
    const fieldsets = variantSelectsEl.querySelectorAll('fieldset[data-option-index]');
    fieldsets.forEach(fs => {
      const idxAttr = fs.getAttribute('data-option-index'); // option1/option2...
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked && idxAttr) {
        const n = parseInt(idxAttr.replace('option',''), 10) - 1;
        selections[n] = checked.value;
      }
    });
    return selections;
  }

  function findVariantByOptions(variants, optionsArr) {
    for (const v of variants) {
      if (!v || !v.options) continue;
      let ok = true;
      for (let i = 0; i < optionsArr.length; i++) {
        if (optionsArr[i] && v.options[i] !== optionsArr[i]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function formatWithDelimiters(number, precision = 2, thousands = ' ', decimal = ',') {
  if (isNaN(number) || number == null) return '0';

  const n = (number / 100).toFixed(precision);
  const parts = n.split('.');
  const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  const cents = parts[1] ? (decimal + parts[1]) : '';
  return dollars + cents;
}

function formatMoney(cents) {
  const format = window.moneyFormat || '€{{amount_with_comma_separator}}';
  const value = String(cents);

  // Supporte les formats Shopify classiques
  if (format.indexOf('{{amount_no_decimals}}') !== -1) {
    return format.replace('{{amount_no_decimals}}', formatWithDelimiters(value, 0, ' ', ','));
  }
  if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
    return format.replace('{{amount_with_comma_separator}}', formatWithDelimiters(value, 2, ' ', ','));
  }
  if (format.indexOf('{{amount_no_decimals_with_comma_separator}}') !== -1) {
    return format.replace('{{amount_no_decimals_with_comma_separator}}', formatWithDelimiters(value, 0, ' ', ','));
  }
  if (format.indexOf('{{amount}}') !== -1) {
    return format.replace('{{amount}}', formatWithDelimiters(value, 2, ',', '.'));
  }

  // fallback si format inattendu
  return '€' + formatWithDelimiters(value, 2, ' ', ',');
}


  function recomputeBallesCards(variantSelectsEl) {
    const variants = readVariantsJSON(variantSelectsEl);
    if (!variants.length) return;

    const current = getCurrentSelections(variantSelectsEl);

    const ballesFs = variantSelectsEl.querySelector('fieldset[data-option-slug="balles"]');
    if (!ballesFs) return;

    const idxAttr = ballesFs.getAttribute('data-option-index'); // option2 etc
    if (!idxAttr) return;
    const ballesIndex = parseInt(idxAttr.replace('option',''), 10) - 1;

    const inputs = ballesFs.querySelectorAll('input[type="radio"][name="Balles"]');

    inputs.forEach(input => {
      const qty = Number(input.value);
      if (!qty) return;

      const candidate = current.slice();
      candidate[ballesIndex] = String(qty);

      const variant = findVariantByOptions(variants, candidate);
      if (!variant) return;

      const label = ballesFs.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;

      const priceEl = label.querySelector('.bundle-card__price');
      const unitEl  = label.querySelector('.bundle-card__unit');

      const saveEl = label.querySelector('.bundle-card__save');
      const discountEl = label.querySelector('.bundle-card__discount');


      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);

      if (unitEl) {
        const unitPrice = Math.round(variant.price / qty);
        unitEl.innerHTML = `${formatMoney(unitPrice)} / balle`;
      }
    });
  }

  function setup() {
    document.querySelectorAll('variant-selects').forEach(vs => {
      recomputeBallesCards(vs);
      vs.addEventListener('change', () => recomputeBallesCards(vs));
      vs.addEventListener('variant:change', () => recomputeBallesCards(vs));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
